module.exports = __webpack_public_path__ + "static/media/seo-search-icon.ac84df89.svg";